import React from "react";
import { Link } from "react-router-dom";
import SpicesSingleProduct from "./uniqueCard";
import { Breadcrumbs } from "./../../Breadcrumb/index";
import { useEffect } from "react";

export default function Spices() {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
          @media (max-width: 998px) {
            .custom-mobile-margin {
              margin-top: 10% !important;
            }
          }
            @media (max-width: 750px) {
            .custom-mobile-margin {
              margin-top: 13% !important;
            }
          }
            
        `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
  return (
    <div className="productPage">
      <div class="container py-5">
        <div class="row">
          <div class="col-lg-12 custom-mobile-margin">
            <div class="row">
              <Breadcrumbs currentPathName="Tin and tin coating product" />
              <div class="col-md-6">
                <ul class="list-inline shop-top-menu pb-3 pt-1">
                  <li class="list-inline-item">
                    <Link
                      class="h3 text-dark text-decoration-none mr-3 text-uppercase"
                      to="/unique"
                    >
                      Tin and tin coating product
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <SpicesSingleProduct />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
